export default __webpack_public_path__ + "static/media/1963.eea25b27.png";